import React, { useState } from "react";
import { telescopicChannels } from "./data/telescopicChannelData";
import "../../App.css";
import { Helmet } from "react-helmet";
import banner from "../../assets/telescopic-channel-banner.webp";

const TelescopicChannel = () => {
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [activeFAQ, setActiveFAQ] = useState(null);
  const [activeTab, setActiveTab] = useState("desc");
const [previewImage, setPreviewImage] = useState(null);
  // YouTube Embed Safe
  const getEmbedUrl = (url) => {
    if (!url) return "";

    if (url.includes("shorts")) {
      const id = url.split("/shorts/")[1]?.split("?")[0];
      return `https://www.youtube.com/embed/${id}`;
    }

    if (url.includes("watch?v=")) {
      const id = url.split("v=")[1]?.split("&")[0];
      return `https://www.youtube.com/embed/${id}`;
    }

    if (url.includes("embed")) return url;

    return "";
  };

  // Watch URL Safe
  const getWatchUrl = (url) => {
    if (!url) return "#";

    if (url.includes("shorts")) {
      const id = url.split("/shorts/")[1]?.split("?")[0];
      return `https://www.youtube.com/watch?v=${id}`;
    }

    if (url.includes("embed")) {
      const id = url.split("/embed/")[1];
      return `https://www.youtube.com/watch?v=${id}`;
    }

    return url;
  };

  const filteredChannels = telescopicChannels.filter(
    (item) => item.category === "telescopic-channel"
  );

  if (!filteredChannels.length) {
    return <p style={{ textAlign: "center" }}>No products found.</p>;
  }

  return (
    <div className="product-container">

      <Helmet>
        <title>Telescopic Drawer Channels | Heavy Duty Drawer Slides</title>
      </Helmet>

      {/* BANNER */}
      <div className="hinge-banners">
        <img src={banner} alt="Channel Banner" loading="lazy" />
        <h2 className="banner-text">Products</h2>
      </div>

      <h2 className="page-title" style={{ textAlign: "center" }}>
        TELESCOPIC SLIDES
      </h2>

      {!selectedChannel ? (

        /* GRID */
        <div className="product-grid">
          {filteredChannels.map((item) => (
            <div
              className="product-card"
              key={item.code}
              onClick={() => {
                setSelectedChannel(item);
                setMainImage(item.mainImage);
                setActiveFAQ(null);
                setActiveTab("desc");
              }}
            >
            <img
  src={item.mainImage}
  alt={item.name}
  loading="lazy"
  onClick={(e) => {
    e.stopPropagation();
    setPreviewImage(item.mainImage);
  }}
  style={{ cursor: "zoom-in" }}
/>
              <h4>{item.name}</h4>
            </div>
          ))}
        </div>

      ) : (

        <>
          {/* BACK */}
          <button
            className="back-btn"
            onClick={() => {
              setSelectedChannel(null);
              setMainImage("");
              setActiveFAQ(null);
              setActiveTab("desc");
            }}
          >
            ← Back
          </button>

          <div className="hinge-details">

            {/* LEFT */}
            <div className="left-box">

              <div className="hinge-image">
                <img
  src={mainImage}
  alt={selectedChannel?.name}
  className="zoomable-image"
  onClick={() => setPreviewImage(mainImage)}
/>
              </div>

              {selectedChannel.thumbnails?.length > 0 && (
                <div className="hinge-thumbnails">
                  {selectedChannel.thumbnails.map((img, i) => (
                    <img
  key={i}
  src={img}
  alt=""
  loading="lazy"
  onClick={() => setMainImage(img)}
  onDoubleClick={() => setPreviewImage(img)}
/>
                  ))}
                </div>
              )}

              {/* VIDEO */}
              {selectedChannel.video && (
                <div className="product-video">
                  <iframe
                    width="100%"
                    height="300"
                    src={getEmbedUrl(selectedChannel.video)}
                    title="Product Video"
                    frameBorder="0"
                    allowFullScreen
                  />
                </div>
              )}

            </div>

            {/* RIGHT */}
            <div className="hinge-info">

              <h2>{selectedChannel.name}</h2>

              {/* PRICE */}
              <div className="price-box">
                <span className="price">{selectedChannel.price}</span>
                <span className="old-price">{selectedChannel.oldPrice}</span>
              </div>

              {/* META */}
              <div className="product-meta">
                {selectedChannel.sku && (
                  <p><strong>SKU:</strong> {selectedChannel.sku}</p>
                )}
                {selectedChannel.stock && (
                  <p><strong>Status:</strong> {selectedChannel.stock}</p>
                )}
              </div>

              {/* BUTTONS */}
              <div className="btns">

                {selectedChannel.catalogue && (
                  <a href={selectedChannel.catalogue} download>
                    📥 Download Catalogue
                  </a>
                )}

                {selectedChannel.inquiry && (
                  <a href={selectedChannel.inquiry} target="_blank" rel="noreferrer">
                    💬 Inquiry
                  </a>
                )}

                {selectedChannel.video && (
                  <a href={getWatchUrl(selectedChannel.video)} target="_blank" rel="noreferrer">
                    ▶ Watch Video
                  </a>
                )}

              </div>

              {/* TABS */}
              <div className="tabs">
                <button
                  className={activeTab === "desc" ? "active" : ""}
                  onClick={() => setActiveTab("desc")}
                >
                  Description
                </button>

                <button
                  className={activeTab === "info" ? "active" : ""}
                  onClick={() => setActiveTab("info")}
                >
                  Additional Info
                </button>
              </div>

              {/* DESCRIPTION */}
              {activeTab === "desc" && (
                <>
                  <p>{selectedChannel.short}</p>
                  <ul>
                    {selectedChannel.features?.map((f, i) => (
                      <li key={i}>{f}</li>
                    ))}
                  </ul>
                </>
              )}

              {/* ADDITIONAL INFO */}
              {activeTab === "info" && (
                <div className="info-table">
                  {selectedChannel.specifications?.length > 0 ? (
                    <table>
                      <tbody>
                        {selectedChannel.specifications.map((s, i) => (
                          <tr key={i}>
                            <td><b>{s.label}</b></td>
                            <td>{s.value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p>No additional info</p>
                  )}
                </div>
              )}

            </div>
          </div>

          {/* SPEC TABLE (ADDED PROPERLY) */}
          {selectedChannel.specTable?.length > 0 && (
            <div className="spec-section">

              <h2>Specifications</h2>

              <table className="spec-table">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Code</th>
                    <th>Size</th>
                    <th>Finish</th>
                  </tr>
                </thead>

                <tbody>
                  {selectedChannel.specTable.map((item, i) => (
                    <tr key={i}>
                      <td>{item.item}</td>
                      <td>{item.code}</td>
                      <td>{item.size}</td>
                      <td>{item.finish}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          )}

          {/* FAQ */}
          {selectedChannel.faq?.length > 0 && (
            <div className="faq-section">

              <h2>Frequently Asked Questions</h2>

              {selectedChannel.faq.map((item, index) => (
                <div key={index} className="faq-box">

                  <div
                    className={`faq-question ${activeFAQ === index ? "active" : ""}`}
                    onClick={() =>
                      setActiveFAQ(activeFAQ === index ? null : index)
                    }
                  >
                    <h4>{item.question}</h4>
                    <span>{activeFAQ === index ? "-" : "+"}</span>
                  </div>

                  {activeFAQ === index && (
                    <div className="faq-answer">
                      <p>{item.answer}</p>
                    </div>
                  )}

                </div>
              ))}

            </div>
          )}
{previewImage && (
      <div
        className="image-preview-modal"
        onClick={() => setPreviewImage(null)}
      >
        <span
          className="image-preview-close"
          onClick={() => setPreviewImage(null)}
        >
          ✕
        </span>

        <img
          src={previewImage}
          alt="Preview"
          className="image-preview-full"
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    )}
        </>
      )}
    </div>
  );
};

export default TelescopicChannel;